import styled, { keyframes } from 'styled-components';

export const SpinnerContainer = styled.div`
    z-index: 1;
    min-height: 440px;
    min-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    50% {
      border-top-color: rgba(255,255,255,.6);
    }
    100% {
        transform: rotate(360deg);
        border-top-color: rgba(255,255,255,1);
    }
`;

export const StyledSpinner = styled.div`
    height: 80px;
    width: 80px;
    border-radius: 50%;
    animation: ${spin} 600ms linear 0s infinite;
    border: 3px solid rgba(0, 0, 0, 0.4);
    border-top: 3px solid white;
`;
